import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// service
import { createProfile } from "../../../utils/services/profilesScreen";
// componentes
import DropOption from "./DropOption";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function ModalNewProfile(props) {
  const { isOpen, toggle, getProfilesList } = props;
  // produtos
  const [allProducts, setAllProducts] = useState([]);
  const [productsWithActions, setProductsWithActions] = useState([]);
  const [showAllEvents, setShowAllEvents] = useState(false);
  // erros
  const [errors, setErrors] = useState({});
  // alertas
  const [alertSuccess, setAlertSuccess] = useState("");
  const [alertError, setAlertError] = useState(false);
  // carregamento
  const [loading, setLoading] = useState(false);

  // verificar erros
  function verifyErrors(e) {
    setLoading(true);

    if (!e.target[0].value) {
      setErrors({
        name: "O campo Nome é obrigatório",
      });

      setLoading(false);
      return;
    } else setErrors({});

    if (
      productsWithActions.filter(
        (e) => e.canView || e.canCreate || e.canEdit || e.canDelete
      ).length === 0
    ) {
      setErrors({
        screens: "Selecione ao menos uma tela",
      });

      setLoading(false);
      return;
    } else setErrors({});

    submitForm(e);
  }

  async function submitForm(e) {
    try {
      // montar a estrutura para api
      const data = {
        description: e.target[0].value,
        isDefault: false,
        contractId: props.state.global_user_data.data.theme[0].id,
        showAllEvents: showAllEvents,
        screensPermission: productsWithActions
          .filter(
            (e) => (e) => e.canView || e.canCreate || e.canEdit || e.canDelete
          )
          .map((obj) => {
            return {
              productId: obj.productId,
              screenId: obj.screenId,
              canCreate: obj.canCreate || false,
              canUpdate: obj.canEdit || obj.canCreate || false,
              canRead:
                obj.canView ||
                obj.canCreate ||
                obj.canEdit ||
                obj.canDelete ||
                false,
              canDelete: obj.canDelete || false,
            };
          }),
      };

      const res = await createProfile(data);

      if (res.message === "PROFILE_CREATED") {
        setAlertSuccess(true);
        getProfilesList();
      } else if (res.data.message === "PROFILE_ALREADY_EXISTS") {
        setAlertError(true);
      }
    } catch (error) {
      console.log("erro", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // pegar apenas os produtos do redux
    var products = [];

    props.state.global_user_data.data.foundProducts.map((e) => {
      var searchProducts = products.find(
        (product) => product.name === e.namemainproduct
      );

      if (!searchProducts) {
        products.push({
          name: e.namemainproduct,
          id: e.idmainproduct,
        });
      }
    });

    setAllProducts(products);
  }, []);

  return (
    <>
      {alertSuccess && (
        <SweetAlert
          success
          title="Criado"
          onConfirm={() => {
            setAlertSuccess(false);
            toggle();
          }}
        >
          Perfil criado com sucesso!
        </SweetAlert>
      )}

      {alertError && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => {
            setAlertError(false);
          }}
        >
          {"Já existe um perfil com esse nome."}
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader toggle={toggle}>Criar Perfil</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              verifyErrors(e);
            }}
          >
            <Row>
              <Col md={7} style={{ marginTop: 10 }}>
                <label className="form-label">Nome*</label>
                <input className="form-control" type="text" />
                {errors && errors.name && (
                  <a style={{ color: "red" }}>{errors.name}</a>
                )}
              </Col>

              <Col md={5} style={{ marginTop: 10 }}>
                <label className="form-label">
                  Pode visualizar todos os eventos?*
                </label>
                <div style={{ display: "flex" }}>
                  <div className="form-check mb-3" style={{ marginRight: 10 }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="viewEvent"
                      id="viewEvent2"
                      value="option2"
                      defaultChecked={true}
                      onClick={() => setShowAllEvents(false)}
                    />
                    <label className="form-check-label" htmlFor="viewEvent2">
                      Não
                    </label>
                  </div>
                  <div className="form-check mb-3" style={{ marginRight: 10 }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="viewEvent"
                      id="viewEvent1"
                      value="option1"
                      defaultChecked={false}
                      onClick={() => setShowAllEvents(true)}
                    />
                    <label className="form-check-label" htmlFor="viewEvent1">
                      Sim
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: 20 }}>
              <Col md={12}>
                <label className="form-label">Produtos e Telas *</label>
              </Col>
            </Row>

            {allProducts &&
              allProducts.length > 0 &&
              allProducts.map((e, i) => (
                <div key={`product${i}`}>
                  <DropOption
                    data={e}
                    allScreens={props.state.global_user_data.data.foundProducts}
                    productsWithActions={productsWithActions}
                    setProductsWithActions={setProductsWithActions}
                  />

                  <div className="line" style={{ marginTop: 10 }} />
                </div>
              ))}
            {errors && errors.screens && (
              <a style={{ color: "red" }}>{errors.screens}</a>
            )}

            <Row
              style={{
                width: "100%",
                margin: "20px auto 0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                className="btn waves-effect waves-light"
                style={{ width: 80, marginRight: 15 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner title={"Salvar"} isLoading={loading} />
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ModalNewProfile);
